import { useEffect, useState } from "react";

import { useAuth0 } from "@auth0/auth0-react";

import { AuthTokenContext } from "components/AuthProvider/AuthProviderContext";

export function AuthTokenProvider({ children }: { children: React.ReactNode }) {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();
  const [token, setToken] = useState<string | null>(null);

  useEffect(() => {
    if (!isAuthenticated) {
      setToken(null);
      return;
    }
    getAccessTokenSilently().then(setToken).catch(() => setToken(null));
  }, [getAccessTokenSilently, isAuthenticated]);

  return (
    <AuthTokenContext.Provider value={token}>
      {children}
    </AuthTokenContext.Provider>
  );
}